<template>
  <div>
    For SMTP.com verification
  </div>
</template>

<script>
  export default {
    
  }
</script>

<style lang="scss" scoped>

</style>